import React, { useEffect } from 'react';
import { MenuComponent } from '../../../../rbts/assets/ts/components';
import { LoadingGrid, TableList } from '../../../../rbts/helpers';
import { useGetAllDonationsList } from '../hooks/DonationsHook';
import { EditarCelda } from './EditarCelda';
type Props = {
  reloadGrid: number;
  onDetails: (row: any) => void;
};

const DonationGrid: React.FC<Props> = ({ reloadGrid, onDetails }) => {
  const { listDonations, loadingRequest } = useGetAllDonationsList(reloadGrid);

  const columns: any = [
    {
      id: 'producto',
      name: <div className="fw-bolder text-muted me-5 ">Producto </div>,
      selector: (row: any) => (row.producto ? row.producto.nombre : 'N/A'),
      cell: (row: any) => (
        <>
          {row.producto ? (
            <>
              <div className="fw-bolder">{row.producto.nombre}</div>
            </>
          ) : (
            <div className="fw-bolder">{row.descripcion}</div>
          )}
        </>
      ),
      sortable: true,
      width: '40%',
    },
    {
      id: 'monto',
      name: <div className="fw-bolder text-muted me-5">Precio pactado</div>,
      selector: (row: any) => (row.producto ? row.producto.costo_sugerido : 0),
      cell: (row: any) =>
        row.producto ? (
          <EditarCelda row={row.producto} />
        ) : (
          <span className="text-muted">-</span>
        ),
      sortable: false,
      width: '30%',
    },
    {
      id: 'cantidad',
      name: (
        <div className="fw-bolder text-muted me-5 ">Cantidad disponible</div>
      ),
      selector: (row: any) => row.cantidad_total,
      cell: (row: any) => (
        <>
          {row.cantidad_total ? (
            <>
              <div className="fw-bolder">{row.cantidad_total}</div>
            </>
          ) : (
            <div className="text-muted">-</div>
          )}
        </>
      ),
      sortable: true,
      width: '20%',
    },
    {
      name: <div className="fw-bolder text-muted me-5">Acciones</div>,
      cell: (row: any) => dropdownRender(row),
      sortable: false,
      width: '10%',
    },
  ];

  const dropdownRender = (row: any) => {
    return (
      <>
        <div className="d-flex justify-content-end flex-shrink-0">
          <div
            data-kt-menu="true"
            className="btn btn-light btn-active-light-primary btn-sm"
            data-kt-menu-trigger="click"
            data-kt-menu-placement="bottom-end"
          >
            Acciones
            <span className="svg-icon svg-icon-5 m-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mh-50px"
              >
                <path
                  d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
          </div>
          <div
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
            data-kt-menu="true"
          >
            <div className="menu-item px-3">
              <div
                className="menu-link px-3"
                onClick={() => {
                  onDetails(row.producto.id);
                }}
              >
                Ver detalle
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  // MenuComponent.reinitialization();

  useEffect(() => {
    MenuComponent.reinitialization();
  }, [loadingRequest]);

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          {loadingRequest ? (
            <LoadingGrid text="Cargando..."></LoadingGrid>
          ) : (
            <TableList data={listDonations} columns={columns}></TableList>
          )}
        </div>
      </div>
    </>
  );
};

export { DonationGrid };
